import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'DISTRICT_UPDATE',
    smsDelete : 'DISTRICT_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        district: [],

        submitSuccess: false,
        districtLoading: false,
        districtError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_DISTRICT(state, district) {
            state.district = district;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        DISTRICT_LOADING (state, loading) {
            state.districtLoading = loading;
        },

        DISTRICT_ERROR (state, hasError) {
            state.districtError = hasError;
        }
    },

    actions: {
        async addDistrict ({commit, dispatch}, payload) {
            commit('DISTRICT_LOADING', true);
            commit('DISTRICT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_district, payload.district, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchDistrict')
                return response

            } catch (e) {
                commit('DISTRICT_ERROR', true);
            } finally {
                commit('DISTRICT_LOADING', false);
            }
        },

        async fetchDistrict ({ commit }) {
            commit('DISTRICT_LOADING', true);
            commit('DISTRICT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.district_list, config);
                let response = result.data
                commit('SET_DISTRICT', response.data);

            } catch(error) {
                commit('DISTRICT_ERROR', true);
            } finally {
                commit('DISTRICT_LOADING', false);
            }
        },

        async fetchDistrictByCountry ({ commit }, payload) {
            commit('DISTRICT_LOADING', true);
            commit('DISTRICT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.district_list_by_country + payload, config);
                let response = result.data
                commit('SET_DISTRICT', response.data);

            } catch(error) {
                commit('DISTRICT_ERROR', true);
            } finally {
                commit('DISTRICT_LOADING', false);
            }
        },

        async updateDistrict ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.update_district + payload.id, payload.district, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchDistrict')
                return response

            } catch (e) {
                commit('DISTRICT_ERROR', true);
            } finally {
                commit('DISTRICT_LOADING', false);
            }
        },
        
        async deleteDistrict({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.district_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchDistrict')
            return response
        }
    },

    getters: {}
}
